/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `ACCEPTED` - Přijato ke zpracování
 *   * `SUCCEEDED` - Úspěch
 *   * `REJECTED` - Odmítnuto protistranou
 *   * `FAILED` - Selhalo
 *   * `CANCELLED` - Zrušeno
 *   * `UNKNOWN` - Neurčeno
 * ```
 */
export const OutcomeEnum = {
  ACCEPTED: 'ACCEPTED',
  SUCCEEDED: 'SUCCEEDED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  UNKNOWN: 'UNKNOWN',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OutcomeEnum = ValuesOf<typeof OutcomeEnum>;

export type OutcomeEnumRequest = OutcomeEnum;
export type OutcomeEnumResponse = OutcomeEnum;
